module.exports = __webpack_public_path__ + "11cd70e867c77490acd20f1150404fba.png";